/**
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import toastr from 'toastr';

/**
 * Provide a toastr abstraction service.
 *
 * Service allows namespacing by passing 'namespace' in config parameter.
 * e.g. Vue.use(Toastr, {namespace: 'jeepersCreepers', name: 'someOtherName'})
 *
 * Service allows scope name change by passing 'name' in config parameter.  In the example below this would place
 * $someOtherName in the Vue instance - so from within a component we would use: this['$someOtherName']
 * e.g. Vue.use(Toastr, {name: 'someOtherName'})
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

function install(Vue: any, config: {options?: ToastrOptions} = {}): void {
    const isSupported: boolean = true;

    // determine if the client supports local storage
    const name: string = 'toastr';

    Vue.mixin({
        beforeCreate(): void {
            if (!isSupported) {
                return;
            }
        },
    });

    if (config.options) {
        toastr.options = config.options;
    }

    Vue[name] = toastr;
    Vue.prototype[`$${name}`] = toastr;
}

export default install;
